/**
 * 文件夹/文件 选择
 */
export default {
    /**
     * 方法
     */
    methods: {
        /**
         * 选择路径
         */
        selectPath: function (next) {
            let _this = this;
            _this._btnClickFun(1, "", function (file) {
                next(file.path)
            })
        },

        /**
         * 添加文件夹
         */
        addFolder: function (next) {
            let _this = this;
            _this._btnClickFun(1, function (folder) {
                let path = folder.path
                window.fs.readdir(path, function (err, files) {
                    if (err) {
                        //读取是否出错
                        window.console.error(err);
                    } else {
                        let types = [
                            'jpg', 'jpeg', 'gif', 'png', 'heic'
                        ];
                        let data = [];
                        for (let i = 0; i < files.length; i++) {
                            let file = files[i];
                            //截取后缀
                            let type = file.split('.').pop().toLowerCase() || ''
                            if (types.indexOf(type) > -1) {
                                let stat = window.fs.statSync(path + '/' + file)
                                let obj = {
                                    name: file,
                                    path: path + '/' + file,
                                    type: type,
                                    size: stat.size,//单位字节
                                    out_format:1,//1为jpg
                                    status: 0,
                                }
                                data.push(obj)
                            }
                        }
                        next(data)
                    }
                })

            })
        },

        /**
         * 添加图片
         */
        addImg: function (next) {
            let _this = this;
            _this._btnClickFun(false, function (files) {
                let datas = [];

                for (let i = 0; i < files.length; i++) {
                    let file = files[i];
                    let type = file.name.split('.').pop().toLowerCase() || '';

                    let obj = {
                        name: file.name,
                        path: file.path,
                        type: type,
                        size: file.size, //单位字节
                        out_format:1,//1为jpg
                        status: 0,
                    }
                    datas.push(obj)
                }
                next(datas);
            })
        },


        /**
         * 弹出选择按钮
         * @param dir 是否选择文件夹
         * @param next 选择后的回调
         */
        _btnClickFun: function (dir, ext, next) {
            if (document.getElementById("_ef")) {
                document.body.removeChild(document.getElementById("_ef"));
            }
            let _this = this;
            // 创建input标签
            let inputObj = document.createElement('input')
            // 设置属性
            inputObj.setAttribute('id', '_ef');
            inputObj.setAttribute('type', 'file');
            inputObj.setAttribute("style", 'visibility:hidden');

            if (dir) { // 如果要选择路径，则添加以下两个属性
                inputObj.setAttribute('webkitdirectory', "");
                inputObj.setAttribute('directory', "");
            } else {
                //可以添加多个
                inputObj.setAttribute("multiple", 'multiple');
                if(ext instanceof Array && ext.length > 0){
                    ext = ext.map(v=>{
                            return '.'+ v;
                        })
                        ext = ext.join(',')
                }else{
                    ext = 'image/x-png,image/gif,image/jpeg,image/bmp,.heic';
                }
                inputObj.setAttribute("accept", ext)
            }
            // 添加到DOM中
            document.body.appendChild(inputObj);
            // 添加事件监听器
            inputObj.addEventListener("change", function () {
                _this._updatePath(_this, next);

            });
            // 模拟点击
            inputObj.click();
        },

        // 打开文件选择器input标签的change事件响应
        _updatePath: function (_this, next) {
            let inputObj = document.getElementById("_ef");
            if (inputObj.hasAttribute('directory')) {
                next(inputObj.files[0]);
            }else{
                next(inputObj.files);
            }



            // 移除事件监听器
            // inputObj.removeEventListener("change", function () {
            // });
            // 从DOM中移除input
            //document.body.removeChild(inputObj);

        },
        //获取文件信息
        getFileInfo(path){
            let stat = window.fs.statSync(path);
            return stat;
        }
    }
}